export function fullPhoneNumber(number?: string) {
  if (number === undefined) return undefined;
  if (number.length > 10) return number;
  return `1${number}`;
}

export function truncateText(text: string, maxLength: number) {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

export const normalizeKey = (key: string) => key.trim().toLowerCase().replace(/\s+/g, '_');
